import CustomStore from 'devextreme/data/custom_store';

type LoadFunction = (loadOptions: any) => Promise<any>;
type CrudFunction = (key: any, data: any) => Promise<any>;
type KeyType = string | string[];

interface StoreOptions {
    key?: KeyType;
    load: LoadFunction;

    // sadece filtre tanımı için byKey
    byKey?: (keyValue: any, loadOptions: any) => void;

    onLoading?: (loadOptions: any) => void;
    onLoaded?: (result: any) => void;

    insert?: CrudFunction;
    update?: CrudFunction;
    remove?: CrudFunction;

    useDefaultSearch?: boolean;
    cacheRawData?: boolean
}

export function createCustomStore({
    key,
    load,
    byKey,
    onLoading,
    onLoaded,
    insert,
    update,
    remove,
    useDefaultSearch = true,
    cacheRawData = false
}: StoreOptions) {
    const storeConfig: any = {
        key,
        load,
        useDefaultSearch,
        cacheRawData
    };

    if (byKey) {
        storeConfig.byKey = async (key: any, loadOptions: any) => {
            if (!key) return null;
            byKey(key, loadOptions);
            const result = await load(loadOptions);
            return result?.data?.[0] ?? null;
        };
    }

    if (onLoading) storeConfig.onLoading = onLoading;
    if (onLoaded) storeConfig.onLoaded = onLoaded;
    if (insert) storeConfig.insert = insert;
    if (update) storeConfig.update = update;
    if (remove) storeConfig.remove = remove;

    return new CustomStore(storeConfig);
}
